import React from "react";
import Logo, { LogoType } from "../../Components/Logo/Logo";
import ukFlag from "../../assets/flags/uk-flag.svg";
import deFlag from "../../assets/flags/de-flag.svg";
import auFlag from "../../assets/flags/au-flag.svg";
import caFlag from "../../assets/flags/ca-flag.svg";
import esFlag from "../../assets/flags/es-flag.svg";
import CountrySelection from "../../Components/CountrySelection/CountrySelection";
import "./CountrySelectionPage.css";

const CountrySelectionPage: React.FC = () => {
  return (
    <div className="country-selection-container">
      <div className="medium-layout country-selection-container-inner">
        <div className="flex flex-col content-center items-center text-center">
          <Logo type={LogoType.Vertical} />
          <div className="country-selection-headline-container">
            <h1 className="country-selection-headline">Welcome to Cora BC</h1>
            <p className="grey">
              To read information about the product, choose the country of your
              residency below:
            </p>
          </div>
        </div>
        <div className="country-grid">
          <CountrySelection
            countryName="Australia"
            countryFlagPath={auFlag}
            countryPath="australia"
          />
          <CountrySelection
            countryName="Canada"
            countryFlagPath={caFlag}
            countryPath="canada"
          />
          <CountrySelection
            countryName="Germany"
            countryFlagPath={deFlag}
            countryPath="germany"
          />
          <CountrySelection
            countryName="United Kingdom"
            countryFlagPath={ukFlag}
            countryPath="uk"
          />
          <CountrySelection
            countryName="Spain"
            countryFlagPath={esFlag}
            countryPath="spain"
          />
        </div>
      </div>
    </div>
  );
};

export default CountrySelectionPage;
